import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import React from 'react'
import { i18n } from '../../domain/index'
import { Campaign, CampaignOffer } from '../types/campaigns'

interface Props {
  open: boolean
  onClose: () => void
  campaign: Campaign | null
}

export default function CampaignOfferModal({ open, onClose, campaign }: Props) {
  const campaignOffers = campaign?.offers

  return (
    <Dialog open={open} onClose={onClose}>
      {campaign && (
        <>
          <DialogTitle>{campaign.name}</DialogTitle>
          <DialogContent>
            {campaignOffers && (
              <>
                {campaignOffers.map((offer, index) => (
                  <CampaignOfferDisplay offer={offer} key={index} />
                ))}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color='primary'>
              {i18n.t('buttons.close')}
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

interface CampaignOfferProps {
  offer: CampaignOffer
}

function CampaignOfferDisplay({ offer }: CampaignOfferProps) {
  const showBuyAndGet =
    offer.buy && offer.buy.productGroups.length > 0 && offer.get && offer.get.productGroups.length > 0
  const showGet = (!offer.buy || !offer.buy.productGroups.length) && offer.get && offer.get.productGroups.length > 0
  return (
    <Box>
      {showBuyAndGet && <BuyAndGetOffer offer={offer} />}
      {showGet && <GetOffer offer={offer} />}
    </Box>
  )
}

function BuyAndGetOffer({ offer }: CampaignOfferProps) {
  return (
    <Box>
      <h3>{i18n.t('campaigns.buyBefore')}</h3>
      {offer.buy?.productGroups.map((group, index) => (
        <div key={index}>
          <p>
            {group.quantity} {i18n.t('campaigns.pieces')}
          </p>
          <p>{group.products.join(', ')}</p>
        </div>
      ))}
      <h3>{i18n.t('campaigns.getAfter')}</h3>
      {offer.get?.totalPrice && (
        <p>
          {i18n.t('campaigns.offerPrice')}: {offer.get?.totalPrice} €
        </p>
      )}
      {offer.get?.productGroups.map((group, index) => (
        <div key={index}>
          <p>
            {group.quantity} {i18n.t('campaigns.pieces')}
          </p>
          {group.priceAmount && <p>Price: {group.priceAmount}</p>}
          <p>{group.products.join(', ')}</p>
        </div>
      ))}
    </Box>
  )
}

function GetOffer({ offer }: CampaignOfferProps) {
  return (
    <Box>
      <h3>{i18n.t('campaigns.get')}</h3>
      {offer.get?.totalPrice && (
        <p>
          {i18n.t('campaigns.offerPrice')}: {offer.get?.totalPrice} €
        </p>
      )}
      {offer.get?.productGroups.map((group, index) => (
        <div key={index}>
          <p>
            {group.quantity} {i18n.t('campaigns.pieces')}
          </p>
          <p>
            {i18n.t('campaigns.products')}: {group.products.join(', ')}
          </p>
        </div>
      ))}
    </Box>
  )
}
